import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'

import mediosDeContacto from '@/store/mediosDeContacto'
import auth from '@/store/auth'
import navigations from '@/store/navigations'
import gestion from '@/store/gestion'
import common from '@/store/common'
import tramites from '@/store/tramites'
import itemEdit from '@/store/itemEdit'
import dataUser from '@/store/dataUser'
import turnos from '@/store/turnos'
import boletas from '@/store/boletas'
import haberes from '@/store/haberes'
import notificaciones from '@/store/notificaciones'
import preafiliacion from '@/store/preafiliacion'
import stepper from '@/store/stepper'
import opcionNivel from '@/store/opcionNivel'
import mediosDePago from '@/store/mediosDePago'
import supervivencia from '@/store/supervivencia'
import subsidios from '@/store/subsidios'
import comunicaciones from '@/store/comunicaciones'
import avisos from '@/store/avisos'

Vue.use(Vuex)
const defaultState = () => ({
  domicilio: [],
  telefono: [],
  email: [],
  familiar: [],
  domicilioPrinc: [],
  telefonoPrinc: [],
  emailPrinc: [],
  mensajeReestablecerPass: {},
  hayDomicilioPrinc: false,
  hayTelefonoPrinc: false,
  hayEmailPrinc: false,
  mensajeCambiarPass: '',
  nroAfiDoc: {
    nroafi: '',
    nrodoc: ''
  },
  errorRecover: '',
  emailAfi: '',
  // Flags de carga por dato — true al iniciar el request, false al terminar (ok o error).
  // Permiten que cada card del Dashboard muestre skeleton solo en su seccion sin
  // depender del loadSkeleton global (que se desactiva con el primer getter).
  loadingDomicilio: true,
  loadingTelefono: true,
  loadingEmail: true,
  loadingFamiliar: true,
});

export default new Vuex.Store({
  namespaced: true,

  modules: {
    auth,
    navigations,
    gestion,
    common,
    itemEdit,
    dataUser,
    turnos,
    notificaciones,
    opcionNivel,
    boletas,
    haberes,
    tramites,
    stepper,
    mediosDePago,
    supervivencia,
    preafiliacion,
    comunicaciones,
    avisos,
    subsidios,
    mediosDeContacto,
  },

  state: defaultState(),

  getters: {
    mensajeCambiarPass(state) {
      return state.mensajeCambiarPass
    },
    domicilio(state) {
      return state.domicilio
    },
    domicilioPrinc(state) {
      return state.domicilioPrinc
    },
    email(state) {
      return state.email
    },
    emailPrinc(state) {
      return state.emailPrinc
    },
    telefono(state) {
      return state.telefono
    },
    telefonoPrinc(state) {
      return state.telefonoPrinc
    },
    familiar(state) {
      return state.familiar
    },
    mensajeReestablecerPass(state) {
      return state.mensajeReestablecerPass
    },
    hayDomicilioPrinc(state) {
      return state.hayDomicilioPrinc
    },
    hayTelefonoPrinc(state) {
      return state.hayTelefonoPrinc
    },
    hayEmailPrinc(state) {
      return state.hayEmailPrinc
    },
    errorRecover(state) {
      return state.errorRecover
    },
    emailAfi(state) {
      return state.emailAfi
    },
    numeroAfi(state) {
      return state.nroAfiDoc.nroafi
    },
    numeroDoc(state) {
      return state.nroAfiDoc.nrodoc
    },
    loadingDomicilio(state) {
      return state.loadingDomicilio
    },
    loadingTelefono(state) {
      return state.loadingTelefono
    },
    loadingEmail(state) {
      return state.loadingEmail
    },
    loadingFamiliar(state) {
      return state.loadingFamiliar
    },

  },
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    setDomicilio(state, domicilio) {
      state.domicilio = domicilio
      state.domicilioPrinc = domicilio.filter(e => e.recibecorreo == 1).find(e => true) || domicilio[0]
      state.hayDomicilioPrinc = domicilio.some(e => e.recibecorreo == 1)
    },
    setTelefono(state, telefono) {
      state.telefono = telefono
      state.telefonoPrinc = telefono.filter(e => e.recibellamada == 1).find(e => true) || telefono[0]
      state.hayTelefonoPrinc = telefono.some(e => e.recibellamada == 1)
    },
    setEmail(state, email) {
      state.email = email
      state.emailPrinc = email.filter(e => e.recibeemail == 1).find(e => true) || email[0]
      state.hayEmailPrinc = email.some(e => e.recibeemail == 1)
    },
    setFamiliar(state, familiar) {
      state.familiar = familiar
    },
    setMensajeReestablecerPass(state, payload) {
      state.mensajeReestablecerPass = payload
    },
    setErrorRecover(state, payload) {
      state.errorRecover = payload
    },
    setEmailAfi(state, payload) {
      state.emailAfi = payload
    },
    setMensajeCambiarPass(state, payload) {
      state.mensajeCambiarPass = payload
    },
    setNroAfiDoc(state, payload) {
      state.nroAfiDoc = payload
    },
    setLoadingDomicilio(state, payload) {
      state.loadingDomicilio = payload
    },
    setLoadingTelefono(state, payload) {
      state.loadingTelefono = payload
    },
    setLoadingEmail(state, payload) {
      state.loadingEmail = payload
    },
    setLoadingFamiliar(state, payload) {
      state.loadingFamiliar = payload
    },
  },

  actions: {
    resetRootState({ commit }) {
      commit('RESET_STATE');
    },
    //method post -> obtener
    async getDomicilio({ commit, dispatch }) {
      commit('setLoadingDomicilio', true)
      await axios({
        method: 'post',
        url: process.env.VUE_APP_API + 'portal/domicilioAfiliado',
        withCredentials: false,
        headers: {
          "Content-Type": "application/json",
        },
        data: { nroafi: sessionStorage.getItem('nroafi') }
      })
        .then(function (response) {
          const res = response.data.message
          commit('setDomicilio', res)
        })
        .catch(function (error) {
          console.log(error);
        }).finally(() => {
          dispatch('auth/setSktLoader', false, { root: true })
          commit('setLoadingDomicilio', false)
        });
    },

    //method put -> actualizar
    async sendDomicilio({ commit, dispatch }, data) {
      await axios({
        method: 'put',
        url: process.env.VUE_APP_API + 'portal/domicilioAfiliado',
        withCredentials: false,
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        data: JSON.stringify(data)
      })
        .then(function (response) {
          const res = response.data.message
          dispatch('notificaciones/showSnack', {
            message: 'Actualizacion correcta',
            type: (response.status).toString()
          }, { root: true })
          dispatch('getDomicilio')
        })
        .catch(function (error) {
          dispatch('notificaciones/showSnack', {
            message: error.response.data.message,
            type: (error.response.status).toString()
          }, { root: true })
        })
    },
    async getTelefono({ commit, dispatch }) {
      commit('setLoadingTelefono', true)
      await axios({
        method: 'post',
        url: process.env.VUE_APP_API + 'portal/telefonoAfiliado',
        withCredentials: false,
        headers: {
          "Content-Type": "application/json",
        },
        data: { nroafi: sessionStorage.getItem('nroafi') }
      })
        .then(function (response) {
          const res = response.data.message
          commit('setTelefono', res)
        })
        .catch(function (error) {
          console.log(error);
        }).finally(() => {
          dispatch('auth/setSktLoader', false, { root: true })
          commit('setLoadingTelefono', false)
        });
    },

    async sendTelefono({ commit, dispatch }, data) {
      await axios({
        method: 'put',
        url: process.env.VUE_APP_API + 'portal/telefonoAfiliado',
        withCredentials: false,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data)
      })
        .then(function (response) {
          const res = response.data.message
          dispatch('notificaciones/showSnack', {
            message: 'Actualizacion correcta',
            type: (response.status).toString()
          }, { root: true })
          dispatch('getTelefono')
        })
        .catch(function (error) {
          dispatch('notificaciones/showSnack', {
            message: error.response.data.message,
            type: (error.response.status).toString()
          }, { root: true })
        }).finally(() => {
          dispatch('auth/setSktLoader', false, { root: true })
        });
    },
    async getEmail({ commit, dispatch }) {
      commit('setLoadingEmail', true)
      await axios({
        method: 'post',
        url: process.env.VUE_APP_API + 'portal/emailAfiliado',
        withCredentials: false,
        data: { nroafi: sessionStorage.getItem('nroafi') },
        headers: {
          "Content-Type": "application/json",
        }
      })
        .then(function (response) {
          const res = response.data.message
          commit('setEmail', res)
        })
        .catch(function (error) {
          console.log(error);
        }).finally(() => {
          dispatch('auth/setSktLoader', false, { root: true })
          commit('setLoadingEmail', false)
        });
    },
    async sendEmail({ commit, dispatch }, data) {
      await axios({
        method: 'put',
        url: process.env.VUE_APP_API + 'portal/emailAfiliado',
        withCredentials: false,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data)
      })
        .then(function (response) {
          const res = response.data.message
          dispatch('notificaciones/showSnack', {
            message: 'Actualizacion correcta',
            type: (response.status).toString()
          }, { root: true })
          dispatch('getEmail')
        })
        .catch(function (error) {
          dispatch('notificaciones/showSnack', {
            message: error.response.data.message,
            type: (error.response.status).toString()
          }, { root: true })
        }).finally(() => {
          dispatch('auth/setSktLoader', false, { root: true })
        });
    },
    async getFamiliar({ commit, dispatch }) {
      commit('setLoadingFamiliar', true)
      await axios({
        method: 'post',
        url: process.env.VUE_APP_API + 'portal/familiarAfiliado',
        withCredentials: false,
        headers: {
          "Content-Type": "application/json",
        },
        data: { nroafi: sessionStorage.getItem('nroafi') }
      }).then((response) => {
        const res = response.data.message

        commit('setFamiliar', res)
      }).catch(function (error) {
        console.log(error)
      }).finally(() => {
        dispatch('auth/setSktLoader', false, { root: true })
        commit('setLoadingFamiliar', false)
      })
    },

    async sendFamiliar({ commit, dispatch }, data) {
      await axios({
        method: 'put',
        url: process.env.VUE_APP_API + 'portal/familiarAfiliado',
        withCredentials: false,
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + sessionStorage.getItem('token')
        },
        data: JSON.stringify(data)
      }).then((response) => {
        const res = response.data.message
        /*         dispatch('notificaciones/showSnack', {
                  message: 'Actualizacion correcta',
                  type: (response.status).toString()
                }, { root: true }) */
        /*         dispatch('notificaciones/showSnack', {
                  message: 'Actualizacion correcta',
                  type: (response.status).toString()
                }, { root: true }) */
        dispatch('getFamiliar')
      }).catch(function (error) {
        console.log(error)
      })
    },
    async recoverPassword({ commit, dispatch }, data) {
      if ((data.captcha !== null) || (typeof (data.captcha) !== "undefined")) {
        await axios({
          method: 'post',
          url: process.env.VUE_APP_API + 'recover',
          withCredentials: false,
          headers: {
            "Content-Type": "application/json",
          },
          data: JSON.stringify(data)
        }).then((response) => {
          const res = response.data.message
          commit('setNroAfiDoc', data)
          commit('setErrorRecover', res.error)
          if (!res.error) {
            commit('setEmailAfi', res.msg)
          }
          else {
            commit('setEmailAfi', res.msg)
          }

          if (typeof (data.function) === 'function') data.function(res)
        }).catch((error) => {
          // Surface el mensaje del backend al usuario en vez de tragarlo en consola.
          const data = (error && error.response && error.response.data) || {};
          const msg = (data.message && data.message.msg) || data.status
            || 'No pudimos procesar tu solicitud. Intentá nuevamente.';
          dispatch('notificaciones/showSnack', { message: msg, type: '400' }, { root: true });
        })
      }
    },
    reestablecerErrorRecover({ commit }) {
      commit('setErrorRecover', '')
    },
    reestablecerMensajeReestablecerPass({ commit }) {
      commit('setMensajeReestablecerPass', {})
    },
    async getValidation({ commit, dispatch }, data) {
      await axios({
        method: 'post',
        //method: 'get',
        url: process.env.VUE_APP_API + 'activate',
        withCredentials: false,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data)
      }).then((response) => {
        if (response.data.message.exito !== 2) {
          const nro = response.data.message.nroafi
          if (!nro) {
            dispatch('notificaciones/showSnack', {
              message: response.data.message.msj,
              type: (nro) ? '200' : '400',
            }, { root: true })
            router.push('/login').catch((() => { }))
          }
          else {
            commit('setMensajeCambiarPass', response.data.message.msj);
          }
        }
      }).catch(function (error) {
        dispatch('notificaciones/showSnack', {
          message: error.response.data.message.msj,
          type: '400',
        }, { root: true })
        //router.push('/Login').catch(() => { })
        console.log(error)
      }).finally(() => {
        dispatch('notificaciones/stopLoading', null, { root: true })
      })
    },

    refreshData({ commit, dispatch }) {
      dispatch('getFamiliar')
      dispatch('getEmail')
      dispatch('getTelefono')
      dispatch('getDomicilio')
    },
  },
});
